import { Controller } from "@hotwired/stimulus"

// Состав заказа: дропдаун «+ Размер», степпер количества (автосейв PATCH designs#update),
// переход в редактор макета по клику на строку размера.
export default class extends Controller {
  static targets = ["menu"]

  toggleMenu(e) {
    e.stopPropagation()
    const menu = e.currentTarget.parentElement.querySelector('[data-order-composition-target="menu"]')
    if (!menu) return
    const opening = menu.hidden
    this.closeMenus()
    menu.hidden = !opening
  }

  closeMenus() {
    for (const menu of this.menuTargets) menu.hidden = true
  }

  step(e) {
    e.stopPropagation()
    const input = document.getElementById(e.currentTarget.dataset.input)
    if (!input) return
    const delta = Number(e.currentTarget.dataset.delta)
    input.value = Math.max(0, (parseInt(input.value, 10) || 0) + delta)
    input.form.requestSubmit()
  }

  openRow(e) {
    const href = e.currentTarget.dataset.href
    if (href) window.location = href
  }

  stop(e) {
    e.stopPropagation()
  }
}
